
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "CardImage",

    props: {
      classes: {
        type: String,
        required: false,
      },

      src: {
        type: String,
        required: true,
      },
    },
  });
